var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-vertical-center"},[_c('p',{staticClass:"property_address"},[_vm._v("\n    "+_vm._s(_vm.recordTitle)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }